import { countryCodes } from "./countryCodes";

export function countrySelector(){
    const selectSelected = document.querySelector('.select-selected');
    const selectItems = document.querySelector('.select-items');
    const countryList = document.getElementById('countryList');
    
    // Generar opciones en la lista personalizada
    countryCodes.forEach(item => {
        const li = document.createElement('li');
        li.textContent = `(${item.code}) ${item.flag} ${item.country}`;
        li.dataset.value = item.code; // Almacenar el código del país como un atributo de datos
        countryList.appendChild(li);
    });
    
    // Mostrar/ocultar la lista de opciones al hacer clic en el selector
    selectSelected.addEventListener('click', function(event) {
        event.stopPropagation();
        selectItems.classList.toggle('select-hide');
    });
    
    // Seleccionar opción al hacer clic
    countryList.addEventListener('click', function(event) {
        if (event.target.tagName === 'LI') {
            selectSelected.textContent = event.target.textContent;
            selectItems.classList.add('select-hide');
            selectSelected.dataset.value = event.target.dataset.value; // Almacenar el código del país seleccionado
        }
    });
    
    // Búsqueda por teclado
    document.addEventListener('keydown', function(event) {
        if (!selectItems.classList.contains('select-hide')) { // Solo buscar si la lista está visible
            const teclaPresionada = event.key.toLowerCase();
            for (let i = 0; i < countryCodes.length; i++) {
                const countryName = countryCodes[i].country.toLowerCase();
                if (countryName.startsWith(teclaPresionada)) {
                    // Seleccionar la opción correspondiente
                    const opciones = countryList.querySelectorAll('li');
                    opciones[i].scrollIntoView(); // Desplazarse a la opción
                    opciones[i].focus(); // Enfocar la opción (opcional)
                    break;
                }
            }
        }
    });
    
    // Cerrar la lista al hacer clic fuera del selector
    document.addEventListener('click', function() {
        selectItems.classList.add('select-hide');
    });

    function adjustDropdownPosition() {
        const selectRect = selectSelected.getBoundingClientRect();
        selectItems.style.bottom = '100%';
        selectItems.style.top = 'auto';
        selectItems.style.left = selectRect.left + 'px';
        selectItems.style.width = selectRect.width + 'px';
        selectItems.style.borderBottomLeftRadius = '0px';
        selectItems.style.borderBottomRightRadius = '0px';
        selectItems.style.borderTopLeftRadius = '5px';
        selectItems.style.borderTopRightRadius = '5px';
    }
}
